(function() {
  let isOpen = false;

  document.addEventListener('kindly:ui', () => {
    if (isOpen) return;
    isOpen = true;
    const chatContainer = document.getElementById('kindly-chat-api')
    const chatButton = document.querySelector('#kindly-chat-api > div')?.shadowRoot?.querySelector('#ChatButtonContainer')
    if (!chatContainer || !chatButton) return;
    chatContainer.style.zIndex = '2147483632';

    const timeout = setInterval(() => {
      const styles = window.getComputedStyle(chatButton)
      if (styles.opacity !== '0') {
        clearTimeout(timeout);
        chatContainer.style.removeProperty('z-index');
        isOpen = false;
      }
    }, 250);
  });

  document.addEventListener('drawerOrModalOpen.drawer-cart', () => {
    window.kindlyChat?.hideBubble();
    window.kindlyChat?.closeChat();
  });

  document.addEventListener('kindly:load', (event) => {
    if (window.kindlyChat.isBrowserCompatible) {
      setTimeout( () => {
        window.kindlyChat.hideBubble();
      })
    }
  });

  document.addEventListener('topMenuChatBubbleClick', () => {
    const hasManualChatStarted = window.localStorage?.getItem('startedManualChatAt');
    if (!hasManualChatStarted) {
      window.kindlyChat.openChat();
    } else {
      window.zE.activate();
    }
  });
})();
